(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sheluet-editorial-service"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sheluet-service-slider')) {
  customElements.define('sheluet-service-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.sh-service__grid');
      const cards = [...this.querySelectorAll('.sh-service__item')];
      const dots = [...this.querySelectorAll('.sh-service__dot')];
      if (!track || !cards.length) return;
      const update = () => {
        const left = track.getBoundingClientRect().left;
        let selected = 0;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect().left - left);
          if (delta < distance) { distance = delta; selected = index; }
        });
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === selected)));
      };
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        const left = track.scrollLeft + cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, {passive: true, signal});
      window.addEventListener('resize', update, {signal});
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
